"use client";

import { useComboboxScopedContext } from "../__chunks/3LH6HMTR.js";
import { useCompositeSeparator } from "../__chunks/QGD6VM2D.js";
import "../__chunks/33WVSQBK.js";
import "../__chunks/APGXEJ2Q.js";
import "../__chunks/G4PVPWEW.js";
import "../__chunks/COWZSPJ7.js";
import "../__chunks/CMXOY7UW.js";
import "../__chunks/JDEWEW7S.js";
import { createElement, createHook, forwardRef } from "../__chunks/7FZLUSKW.js";
import "../__chunks/HNHAUIIY.js";
import "../__chunks/SK3NAZA3.js";
import { __objRest, __spreadValues } from "../__chunks/3YLGPPWQ.js";

// src/combobox/combobox-separator.tsx
import { invariant } from "@ariakit/core/utils/misc";
var TagName = "hr";
var useComboboxSeparator = createHook(function useComboboxSeparator2(_a) {
  var _b = _a,
    store = _b.store,
    props = __objRest(_b, ["store"]);
  var context = useComboboxScopedContext();
  store = store || context;
  invariant(store, process.env.NODE_ENV !== "production" && "ComboboxSeparator must be wrapped in a ComboboxList or ComboboxPopover component.");
  props = useCompositeSeparator(__spreadValues({
    store: store
  }, props));
  return props;
});
var ComboboxSeparator = forwardRef(function ComboboxSeparator2(props) {
  var htmlProps = useComboboxSeparator(props);
  return createElement(TagName, htmlProps);
});
export { ComboboxSeparator, useComboboxSeparator };